import { request } from '@/api/service'

export function SYS_USER_LOGIN (data) {
  return request({
    url: '/corp_wx/webpage/user/detail_info/',
    method: 'post',
    data
  })
}

/*
* 代客-获取编码的user_id
*/
export function reform_id_user_id (query) {
  return request({
    url: 'corp_wx/sub_app/reform_id/user_id/',
    method: 'get',
    params: query
  })
}

export function SYS_USER_LOGOUT (data) {
  return request({
    url: 'api/logout/',
    method: 'post',
    data
  })
}
export function update_user_info (data) {
  return request({
    url: '/user_manage/wx_corp_contacts/user/update/',
    method: 'post',
    data
  })
}



